import LegalLayout, { LegalSection } from "../../components/chalk/LegalLayout";

export default function DeleteData() {
  return (
    <LegalLayout title="Delete My Data" eyebrow="Legal" lastUpdated="February 2026" testId="page-delete-data">
      <LegalSection heading="Request deletion">
        <p>
          To request deletion of your Chalk OS account, guardian profile, athlete-linked data, or
          team data you control, email{" "}
          <a href="mailto:support@getchalkos.com" style={{ color: "#2E7D52" }}>support@getchalkos.com</a>{" "}
          from the email address connected to your account.
        </p>
      </LegalSection>

      <LegalSection heading="What to include">
        <p>Please include in your request:</p>
        <ul style={{ paddingLeft: 22, margin: 0, display: "flex", flexDirection: "column", gap: 8, fontSize: 15, lineHeight: 1.65 }}>
          <li>Your full name as it appears on the account.</li>
          <li>The team name (or league name, if you're a league admin).</li>
          <li>The specific data you want deleted (account, athlete profile, message history, etc.).</li>
        </ul>
      </LegalSection>

      <LegalSection heading="Identity verification">
        <p>
          We may need to verify your identity before processing the request. This protects against
          impersonation and ensures we're deleting data on behalf of the right person — especially
          for athlete profiles that may be linked to multiple guardians.
        </p>
      </LegalSection>

      <LegalSection heading="What gets deleted">
        <p>
          Once verified, we delete or anonymize the requested personal data from active systems.
          Some records may be retained where required for billing, security, audit logs, legal
          compliance, or dispute prevention. Backup snapshots are overwritten on our standard
          retention cycle.
        </p>
      </LegalSection>

      <LegalSection heading="Timing">
        <p>
          We respond to deletion requests within five business days of receipt and complete the
          deletion within thirty days of verification, unless a longer timeframe is required by law.
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
